import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slider", "prev", "next"]

  connect() {    
    this.isDown = false
    this.isDragging = false

    this.updateButtons = this.updateButtons.bind(this)
    this.mouseUp = this.mouseUp.bind(this)
    this.mouseMove = this.mouseMove.bind(this)

    this.sliderTarget.addEventListener("mousedown", this.mouseDown.bind(this))
    this.sliderTarget.addEventListener("mousemove", this.mouseMove)
    this.sliderTarget.addEventListener("scroll", this.updateButtons)
    document.addEventListener("mouseup", this.mouseUp)
    window.addEventListener("resize", this.updateButtons)

    this.resizeObserver = new ResizeObserver(this.updateButtons)
    this.resizeObserver.observe(this.sliderTarget)

    this.updateButtons()
  }

  disconnect() {
    document.removeEventListener("mouseup", this.mouseUp)
    window.removeEventListener("resize", this.updateButtons)
    this.resizeObserver?.disconnect()
  }

  prev(event) {
    event.preventDefault()

    this.sliderTarget.scrollBy({
      left: -300,
      behavior: "smooth"
    })
  }

  next(event) {
    const atEnd =
      Math.ceil(this.sliderTarget.scrollLeft + this.sliderTarget.clientWidth) >=
      this.sliderTarget.scrollWidth - 1
    if (!atEnd) {
      event.preventDefault()

      this.sliderTarget.scrollBy({
        left: 300,
        behavior: "smooth"
      })
    }
  }

  mouseDown(event) {
    this.isDown = true
    this.isDragging = false
    this.sliderTarget.classList.add("dragging")
    this.startX = event.pageX
    this.scrollLeft = this.sliderTarget.scrollLeft
  }

  mouseUp() {
    if (!this.isDown) return

    this.isDown = false
    this.sliderTarget.classList.remove("dragging")

    setTimeout(() => {
      this.isDragging = false
      this.updateButtons()
    }, 10)
  }

  mouseMove(event) {
    if (!this.isDown) return

    event.preventDefault()

    const walk = event.pageX - this.startX

    if (Math.abs(walk) > 5) this.isDragging = true

    this.sliderTarget.scrollLeft = this.scrollLeft - walk
  }

  updateButtons() {
    if (this.hasPrevTarget) {
      this.prevTarget.disabled = this.sliderTarget.scrollLeft <= 0
    }

    if (this.hasNextTarget) {
      this.nextTarget.classList.toggle(
        "disabled",
        Math.ceil(this.sliderTarget.scrollLeft + this.sliderTarget.clientWidth) >=
          this.sliderTarget.scrollWidth - 1
      )
    }
  }
}